import styled from 'styled-components';

import { Button, Card } from '@gympass/yoga';

export const NotesSection = styled(Card)`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const NotesContent = styled(Card.Content)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const NotesViewButton = styled(Button.Link)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
`;

export const NotesAddButton = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const NotesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
